


































































import Vue from 'vue';
import CancelMembershipRequestViewModel from '@/src/services/viewModel/resource/CancelMembershipRequestViewModel';

export default Vue.extend({
  auth: true,
  data: () => ({
    yearList: undefined as any,
    isSaving: false,
    errorResponse: undefined as string | undefined,
    membershipHasBeenCancelled: false,
    cancelMembershipReq: new CancelMembershipRequestViewModel(),
    specifiedCancellationDate: undefined as number | undefined,
    reasonType: [
      { id: 0, caption: Vue.$tEnum('page.memberData.label.reasonEnum', 0) },
      { id: 1, caption: Vue.$tEnum('page.memberData.label.reasonEnum', 1) },
      { id: 2, caption: Vue.$tEnum('page.memberData.label.reasonEnum', 2) },
    ],
  }),
  computed: {
    tenant() {
      return this.$route.params.tenant;
    },
    workspace() {
      return this.$route.params.workspace;
    },
  },
  mounted() {
    const currentYear = this.$date.now().year();
    const timeForCancellation = this.$date(new Date(currentYear, 6, 30));
    if (this.$date.now() > timeForCancellation) {
      this.specifiedCancellationDate = currentYear + 1;
    } else {
      this.specifiedCancellationDate = currentYear;
    }
    this.cancelMembershipReq.cancellationDate = this.$date(new Date(this.specifiedCancellationDate, 11, 31)).format('YYYY-MM-DD');
    this.loadListOfYears();
  },
  methods: {
    loadListOfYears() {
      const list = [];
      for (let year = this.specifiedCancellationDate!; year < this.specifiedCancellationDate! + 100 + 1; year += 1) {
        list.push({ caption: this.$date(new Date(year, 11, 31)).format('DD.MM.YYYY'), id: this.$date(new Date(year, 11, 31)).format('YYYY-MM-DD') });
      }
      this.yearList = list;
    },
    navigateBackToOverview() {
      this.$router.push('/syna/memberPortal/member-data/member-data-change');
    },
    async cancelMembership() {
      if (!this.cancelMembershipReq.validate()) {
        return;
      }
      this.isSaving = true;
      this.membershipHasBeenCancelled = false;
      this.errorResponse = '';
      try {
        await this.$service.api.memberships.cancelMyMembership(this.cancelMembershipReq);
        this.membershipHasBeenCancelled = true;
      } catch (error: any) {
        this.errorResponse = error;
      }
      this.isSaving = false;
    },
  },
});
